export default {
  cartButton: {
    id: 'outlet_home_cart_button',
    defaultMessage: 'Shopping cart',
  },
  back: {
    id: 'outlet_detail_back',
    defaultMessage: 'Back',
  },
}
